import { el } from '../core/dom.js';

function host() {
  let node = document.getElementById('toasts');
  if (!node) {
    node = el('div', { id: 'toasts', class: 'toasts', 'aria-live': 'polite' });
    document.body.append(node);
  }
  return node;
}

/** @param {string} message @param {'info'|'error'} [tone] */
export function toast(message, tone) {
  const node = el('div', { class: tone === 'error' ? 'toast toast-error' : 'toast', role: 'status' }, message);
  host().append(node);
  window.setTimeout(() => node.remove(), 4200);
}
